import { AES, enc } from "crypto-js";
import { env } from "./env";

const secret = env.NEXT_PUBLIC_ENCRTYPTION_SECRET;

export function decrypt(value: string) {
  const decrypted = AES.decrypt(value, secret);
  const object = decrypted.toString(enc.Utf8);

  return object
}
